import React from 'react';

export const PageTitle = ({ children }) => {
	const styleTitle = {
		color: 'coral',
	};
	return <h1 style={styleTitle}>{children}</h1>;
};
